import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "../util";

// Helper function for sorting
const compare = (a, b) => {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
};

export const getWaterUsageList = ({
  productId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + productId + "/water-usage",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data.map((data) => {
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const addWaterUsageToProduct = ({
  productId,
  method = "emission_factor",
  water_type,
  qty,
  qty_unit,
  water_supplier,
  country,
  currency,
  price_per_functional_unit,
  manuel,
  manuel_unit,
  product_code,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    method: method,
    water_type: water_type,
    qty: qty || null,
    qty_unit: qty_unit || null,
    water_supplier: water_supplier || null,
    country: country || null,
    currency: currency || null,
    price_per_functional_unit: price_per_functional_unit || null,
    manuel: manuel || null,
    manuel_unit: manuel_unit || null,
    product_code: product_code || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/product/" + productId + "/water-usage",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
        setErrorMessage(error.response.data);
      }
    });
};

export const getWaterUsage = ({ id, setObjects, objects, componentId }) => {
  var config = {
    method: "get",
    url:
      baseUrl + "/api/business/product/" + id + "/water-usage/" + componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data)

      setObjects(
        objects.map((component) => {
          if (component.id === componentId) {
            const newComponent = response.data.data;

            // newComponent.physical_unit = newComponent.category.physical_unit

            return newComponent;
          }
          return component;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateWaterUsage = ({
  productId,
  componentId,
  method = "emission_factor",
  water_type,
  qty,
  qty_unit,
  water_supplier,
  country,
  currency,
  price_per_functional_unit,
  manuel,
  manuel_unit,
  product_code,
  objects,
  setObjects = function () {
    return;
  },
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    method: method,
    water_type: water_type,
    qty: qty || null,
    qty_unit: qty_unit || null,
    water_supplier: water_supplier || null,
    country: country || null,
    currency: currency || null,
    price_per_functional_unit: price_per_functional_unit || null,
    manuel: manuel || null,
    manuel_unit: manuel_unit || null,
    product_code: product_code || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/water-usage/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      setErrorMessage(error.response.data);
    });
};

export const deleteWaterUsage = ({
  productId,
  componentId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/water-usage/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getWaterUsageCountryData = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/water-usage-country-data",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdown(
        response.data.data
          .map((country) => {
            country.value = country.name;
            country.id = country.name;
            return country;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterUsageSuppliersDropdown = ({
  businessId,
  year,
  setDropdown,
}) => {
  const config = {
    method: "get",
    url:
      baseUrl +
      `/api/business/water-usage-suppliers-dropdown?business=${businessId}${
        year ? `&year=${year}` : ""
      }`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const suppliers = response.data.data.suppliers || [];
      setDropdown(
        suppliers
          .map((supplier) => ({
            value: supplier,
            id: supplier,
            label: supplier,
          }))
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
      // Return empty array on error
      setDropdown([]);
    });
};

export const getWaterMeasurementUnits = ({ setUnits }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/water-measurement-units",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const data = response.data.data;
      setUnits({
        quantityUnits: data.quantity_units || [],
        emissionFactorUnits: data.emission_factor_units || [],
      });
    })
    .catch(function (error) {
      console.log(error);
      // Return empty arrays on error
      setUnits({
        quantityUnits: [],
        emissionFactorUnits: [],
      });
    });
};
